<template>
    <GridImageWithName
        root-class="categories-list"
        :list="list"
        :inside-redirect="true"
    />
</template>

<script>
import GridImageWithName from '~/components/common/GridImageWithName';

export default {
    name: 'CategoriesList',
    components: {
        GridImageWithName,
    },
    props: {
        list: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss">
    .categories-list {
        width: calc(100% + 20px);
        margin: 0 -10px;

        &__item {
            line-height: 0;
        }

        &__image-wrapper {
            max-width: 266px;
            height: 233px;
        }

        &__name-wrapper {
            padding-top: 6px;
            min-height: 48px;
            padding-bottom: 2px;
        }
    }

    @media (max-width: $breakpoint-big-desktop) {
        .categories-list__image-wrapper {
            max-width: 213px;
            height: 186px;
        }
    }

    @media (max-width: $breakpoint-small-desktop) {
        .categories-list__image-wrapper {
            max-width: 226px;
            height: auto;
        }
    }

    @media (max-width: $breakpoint-tablet) {
        .categories-list {
            &__name-wrapper {
                padding-top: 16px;
                min-height: 40px;
            }

            &__image-wrapper {
                max-width: 100%;
                height: auto;
                max-height: 158px;
                min-height: 120px;
            }
        }
    }
</style>
